import { injectGlobal } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import ThemeConsumer from 'embed/components/ThemeConsumer'

import { offerStyleIsCompactSelector } from 'embed/selectors'
import { MultiProductState } from 'embed/reducers'

export interface GlobalStylesProps {
  offerStyleIsCompact: boolean
}

const GlobalStyles: React.FC<GlobalStylesProps> = ({ offerStyleIsCompact }) => (
  <ThemeConsumer>
    {({ colorBorder, colorSecondary, colorTextPrimary, colorTextSecondary, fontFamilySecondary, fontSizeBase }) => {
      injectGlobal(`

       @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700');

        html {
          font-size: ${fontSizeBase};

          @media (max-width: 750px) {
            font-size: ${offerStyleIsCompact ? '16px' : '12px'};
          }
        }
        body {
          background: transparent;
          color: ${colorTextPrimary};
          font-family: ${fontFamilySecondary},
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            'Roboto',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            sans-serif;
        }
        input, .Select-control {
          border-color: ${colorBorder};
          font-family: ${fontFamilySecondary},
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            'Roboto',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            sans-serif;
        }
        input[type=radio] {
          border: none;
          padding: 0;
        }
        input[type=radio]:after {
          position: absolute;
          left: -1px;
          bottom: 0;
          top: -1px;
          right: 0;
          width: 16px;
          height: 16px;
          border-radius: 16px;
          content: '';
          display: inline-block;
          visibility: visible;
          border-width: 0;
      }

      input[type=radio]:checked {
         &:after {

          background-color: ${colorSecondary} ;
          content: '';
          display: inline-block;
         }
      }
        a {
          color: ${colorTextSecondary};

          &:active,
          &:hover {
            color: ${colorTextPrimary};
          }
        }`)
      return null
    }}
  </ThemeConsumer>
)

const mapStateToProps = (state: MultiProductState) => ({
  offerStyleIsCompact: offerStyleIsCompactSelector(state),
})

export default connect(mapStateToProps)(GlobalStyles)
